/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import delay from 'lodash/delay';
import { Button, DisplayHtmlContent, Heading, Icon, Inline, Spacer } from 'sarsaparilla';
import { convertToDegrees } from '../utils';

function GettingHere({ drivingDirection, latitude, longitude }) {
    const [copied, setCopied] = useState(false);
    const copyCoordinates = () => {
        navigator.clipboard.writeText(
            `${convertToDegrees(latitude)} ${convertToDegrees(longitude, true)}`
        );
        setCopied(true);
        delay(() => setCopied(false), 2000);
    };
    return (
        <>
            <Heading headingLevel={3} appearance="h4">
                Directions
            </Heading>
            <Spacer size="gutter" />
            <Heading headingLevel={4} appearance="h5">
                Driving Directions
            </Heading>
            <Spacer size="sm" />
            <DisplayHtmlContent html={drivingDirection} />
            <Spacer size="gutter" />
            <Heading headingLevel={4} appearance="h5">
                Directions
            </Heading>
            <Spacer size="sm" />
            <Inline>
                <div>
                    <Heading headingLevel={5} appearance="h6">
                        Latitude
                    </Heading>
                    <Spacer size="xs" />
                    {latitude ? convertToDegrees(latitude) : 'N/A'}
                </div>
                <Spacer size="gutter" />
                <div>
                    <Heading headingLevel={5} appearance="h6">
                        Longitude
                    </Heading>
                    <Spacer size="xs" />
                    {longitude ? convertToDegrees(longitude, true) : 'N/A'}
                </div>
            </Inline>
            {latitude !== 0 && longitude !== 0 && (
                <Inline>
                    <Button
                        onClick={copyCoordinates}
                        appearance="tertiary"
                        size="xs"
                        iconBeforeElement={<Icon iconName="clipboard" />}
                    >
                        Copy to Clipboard
                    </Button>
                    <Spacer size="gutter" />
                    <div aria-live="polite">
                        {copied && (
                            <span>
                                <Icon
                                    iconName="check-circle"
                                    size="sm"
                                    className="mr-half"
                                />
                                Copied
                            </span>
                        )}
                    </div>
                </Inline>
            )}
        </>
    );
}

GettingHere.propTypes = {
    drivingDirection: PropTypes.string.isRequired,
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
};

export default GettingHere;
